module.exports = __webpack_public_path__ + "static/img/00_mtgf.34f2960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/thirdLine/00_mtgf.png
// module id = nVS0
// module chunks = 0